var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-layout',[[_c('details-page-title',{attrs:{"title":_vm.$t(
          'components.marketPlaceManagement.buyers.details.buyerManagement.headline'
        ),"details-id":_vm.id}}),_c('details-page-header',{attrs:{"name":_vm.getName,"badge":_vm.getBadge,"avatar":_vm.getAvatar,"email":_vm.getEmail,"tabs":_vm.tabs}}),_c('div',{staticClass:"min-h-screen"},[_c('router-view')],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }